import React from 'react'
import { graphql } from 'gatsby'

import * as styles from 'src/styles/pages/terms.module.scss'

import Seo from 'common/Seo'
import Layout from 'common/Layout'
import Section from 'common/Section'

import useMeta from 'hooks/useMeta'
import useRichText from 'hooks/useRichText'

export default function PrivacyPolicyPage({ data: { page } }) {
  const { body } = page.components[0]

  return (
    <Layout mobileTheme="light">
      <Section className={styles.section}>
        <Body body={body} />
      </Section>
    </Layout>
  )
}

const Body = ({ body }) => {
  const renderText = useRichText({
    text: body,
    as: 'div',
  })

  return <div className={styles.body}>{renderText}</div>
}

export const Head = ({ location, data: { page } }) => {
  const meta = useMeta(page)
  return <Seo {...meta} pathname={location.pathname} />
}

export const query = graphql`
  {
    page: contentfulPage(pageID: { eq: "privacy-policy" }) {
      ...Page
    }
  }
`
